export enum ClientBusinessLine {
    default,
    other,
    proctor,
}
